import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import StarUnstarredIcon from '@atlaskit/icon/core/star-unstarred';

import type {
	ForYouListFilterConfig,
	ForYouQueryHook,
	NavItemConfig,
	StarredItem,
} from '../../common/types';

import { STARRED_TEST_ID } from './constants';
import { messages } from './messages';

export interface StarredProps {
	useStarredItems: ForYouQueryHook<StarredItem>;
	searchable?: boolean;
	filters?: ForYouListFilterConfig[];
	viewAllHref?: string;
	viewAllOnClick?: React.MouseEventHandler<HTMLButtonElement>;
	peek?: boolean;
}

export default function makeStarredNavItem({
	useStarredItems,
	searchable = true,
	filters,
	viewAllHref,
	viewAllOnClick,
	peek = false,
}: StarredProps): NavItemConfig {
	const icon = <StarUnstarredIcon label="" />;

	return {
		type: 'flyout',
		testId: STARRED_TEST_ID,
		triggerLabel: <FormattedMessage {...messages.starredLabel} />,
		elemBefore: icon,
		isDefaultOpen: peek,
		children: 'TODO: Starred items go here',
	};
}
